var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('edit-building',{attrs:{"data-test-id":"edit-building","project-id":_vm.projectId,"building-id":_vm.buildingId,"copy":_vm.copy,"title":_vm.$t('editBuildingTitle'),"submit-text":"validateAndSave","handle-submit":_vm.validationSuccess}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }